import { render, staticRenderFns } from "./pjnoticebypid.vue?vue&type=template&id=35c211e9&scoped=true"
import script from "./pjnoticebypid.vue?vue&type=script&lang=js"
export * from "./pjnoticebypid.vue?vue&type=script&lang=js"
import style0 from "./pjnoticebypid.vue?vue&type=style&index=0&id=35c211e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c211e9",
  null
  
)

export default component.exports